// About.js
import React from 'react';

function About() {
  return <h2>About</h2>;
}

export default About;
